import {List, ListItem, Typography} from '@mui/material';

interface Props {
  listItems: string[];
}
export const BulletList = ({listItems}: Props) => {
  return (
    <>
      {listItems.map((item, idx) => (
        <List
          key={`entry-${item}-${idx}`}
          sx={{
            listStyleType: 'disc',
            pl: 5,
            padding: '0px 0px 0px 34px',
          }}
        >
          {item.length > 0 && (
            <ListItem
              sx={{
                display: 'list-item',
              }}
            >
              <Typography key={`text-${idx}`} variant='body1' dangerouslySetInnerHTML={{__html: item}} />
            </ListItem>
          )}
        </List>
      ))}
    </>
  );
};
